module.exports = __webpack_public_path__ + "img/feedback5-3.4ebce8a3.jpg";